module.exports = __webpack_public_path__ + "img/Bear08.338b9ce7.jpg";